<template>
  <Popup :show="props.modelValue" @update:show="$emit('update:modelValue', $event)" :style="{ background: 'transparent' }" :close-on-click-overlay="maskClosable">
    <div class="dialog" :class="cssType + ' ' + size">
      <div class="dialog-title">{{ title }}</div>
      <div class="dialog-content">
        <slot></slot>
      </div>
      <div class="dialog-close" v-if="showClose" @click="$emit('update:modelValue', false);$emit('close')"></div>
    </div>
  </Popup>
  <!-- <div class="dialog" :class="cssType" v-if="props.modelValue">
    <div class="dialog-mask"></div>
    <div class="dialog-content" :class="type">
      <slot></slot>
      <div class="dialog-close" :class="type" @click="handleClose" v-if="showClose"></div>
    </div>
  </div> -->
</template>

<script setup>
import { Popup } from 'vant'
import { defineProps, watch } from 'vue'
import { isMobile } from '@/utils'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: '', // large
  },
  showClose: {
    type: Boolean,
    default: true
  },
  title: {
    type: String,
    default: ''
  },
  maskClosable: {
    type: Boolean,
    default: true
  }
})

watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    document.body.classList.add('lock-scroll')
  } else {
    document.body.classList.remove('lock-scroll')
  }
}, { immediate: true })

// const emit = defineEmits(['update:modelValue'])

// const handleClose = () => {
//   emit('update:modelValue', false)
// }
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>

<style>
.van-popup--center {
  max-width: 100% !important;
}
</style>